export const MODULE_ADMIN_ACCESS_MESSAGE =
  "You don't have permission to perform this action. Modules can only be edited in the account or space where they were created";
